import { Icon } from "@blueprintjs/core";

import { pluralize } from "@/components/helpers/string-utils";
import { Box } from "@/components/layout/flexbox";
import { DateTimeDisplay } from "@/components/pieces/DateTimeDisplay";

interface GrantExtensionInfoComponentProps {
  grantedCloseDate?: string | null;
  grantedCloseDateUserIds?: Array<number> | null;
}

export function GrantExtensionInfoComponent({
  grantedCloseDate,
  grantedCloseDateUserIds,
}: GrantExtensionInfoComponentProps) {
  const participantCount = grantedCloseDateUserIds?.length || 0;
  const participantText = pluralize({
    amount: participantCount,
    singular: "Participant",
    plural: "Participants",
  });
  return (
    <Box my={2}>
      <Icon icon="time" style={{ marginRight: 8 }} />
      <strong>{participantText}</strong> have been granted an extension until{" "}
      <DateTimeDisplay
        time={grantedCloseDate}
        formatString="MMM d, yyyy 'at' h:mm a"
      />{" "}
      PT
    </Box>
  );
}
